// app bar, heigth 60px

import React from "react";
import { Link } from "react-router-dom";
import { BellBlueSvg, SpgecBlueSvg } from "../components/Assets";
import { ROUTE_PATHS } from "../constants/Router";
import { useState,useEffect } from "react";
import NotificationApi from "../apis/notification.api";
import '../assets/styles/appbar.css';
const AppBarLeft = () => {
  return (
    <div className="flex" style={{ gap: "5px" }}>
      <Link to={ROUTE_PATHS.Home}>
        <img style={{ height: "20px" }} src={SpgecBlueSvg}></img>
      </Link>
      {/* <span style={{
            color: 'white',
            fontWeight: 'bold',
        }}>Union</span>
        <span style={{
            borderRadius: '5px',
            background: 'white',
            color: '#3451D7',
            fontWeight: 'bold',
            padding: '0 2px',
        }}>
            사장님
        </span> */}
    </div>
  );
};
const AppBarRight = () => {
  const [unreadNotiCount,setUnreadNotiCount] = useState(0);
  const getNotificationStatus = async () => {
    const { data } = await NotificationApi.getStatus();
    if (data.data) {
      setUnreadNotiCount(data.data);
    }
  };
  useEffect(()=>{
    getNotificationStatus();
  },[]);
  return (<div>
  {unreadNotiCount>0 &&  <div className="badge"></div>}
  <Link to={ROUTE_PATHS.Notification}>
      <img src={BellBlueSvg}></img>
    </Link>
  </div>
  
  );
};
const AppBar2 = ({ hideNotification }) => {
  return (
    <div
    className="appbar2 flex justify-between items-center fixed top-0 left-0 z-10 w-full bg-white"
    style={{ height: "60px", padding: "0 20px" }}
    >
      <AppBarLeft />
      {!hideNotification && <AppBarRight />}
    </div>
  );
};
export default AppBar2;
